import { refusalReasonFromError } from "%/helpers/member-post-refusal";
import {
  REASON_COMMENT_EMPTY,
  REASON_COMMENT_MEDIA_NOT_ALLOWED,
  REASON_COMMENT_TOO_LONG,
} from "%/dynamic-component-editor/helpers/story-comments.mjs";

export const REASON_COMMENTS_OFF = "comments_off";
export const REASON_REPLIES_OFF = "replies_off";
export const REASON_LIKES_OFF = "comment_likes_off";
export const REASON_VOTES_OFF = "comment_votes_off";
export const REASON_REPLY_TOO_DEEP = "reply_too_deep";
export const REASON_STORY_NOT_VISIBLE = "story_not_visible";
export const REASON_SIGN_IN_REQUIRED = "sign_in_required";
export const REASON_READER_BLOCKED = "reader_blocked";
export const REASON_COMMENT_UNAVAILABLE = "comment_unavailable";
export const REASON_NOT_A_MODERATOR = "not_a_moderator";

const MESSAGE_BY_REASON = {
  [REASON_COMMENTS_OFF]: "Comments are turned off on this post.",
  [REASON_REPLIES_OFF]: "Replies are turned off on this post.",
  [REASON_LIKES_OFF]: "Liking comments is turned off on this post.",
  [REASON_VOTES_OFF]: "Voting on comments is turned off on this post.",
  [REASON_REPLY_TOO_DEEP]: "Reply to the original comment instead.",
  [REASON_STORY_NOT_VISIBLE]: "This post is not available to you.",
  [REASON_SIGN_IN_REQUIRED]: "Sign in to comment.",
  [REASON_READER_BLOCKED]: "You can't comment here.",
  [REASON_COMMENT_UNAVAILABLE]: "That comment isn't available any more.",
  [REASON_NOT_A_MODERATOR]: "Only this destination's moderators can do that.",
  [REASON_COMMENT_EMPTY]: "Write something first.",
  [REASON_COMMENT_TOO_LONG]: "That's too long for a comment. Keep it under 5,000 characters.",
  [REASON_COMMENT_MEDIA_NOT_ALLOWED]: "Comments can only hold text.",
};

const FALLBACK_MESSAGE = "That did not post. Your words are still here — try again.";
const REPORT_FALLBACK_MESSAGE = "Your report did not send. Try again.";
const MODERATION_FALLBACK_MESSAGE = "That did not save. Try again.";

export function commentRefusalMessage(error) {
  return commentRefusalMessageFor(refusalReasonFromError(error));
}

export function commentRefusalMessageFor(reason) {
  return MESSAGE_BY_REASON[reason] ?? FALLBACK_MESSAGE;
}

export function reportRefusalMessage(error) {
  return MESSAGE_BY_REASON[refusalReasonFromError(error)] ?? REPORT_FALLBACK_MESSAGE;
}

export function moderationRefusalMessage(error) {
  return MESSAGE_BY_REASON[refusalReasonFromError(error)] ?? MODERATION_FALLBACK_MESSAGE;
}
